/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetCustomerResponse } from '../model';
// @ts-ignore
import { GetCustomersPagingResponse } from '../model';
// @ts-ignore
import { GetCustomersResponse } from '../model';
// @ts-ignore
import { GetLocationsCustomerResponse } from '../model';
// @ts-ignore
import { GetTotalDataResponse } from '../model';
// @ts-ignore
import { PostCustomerRequest } from '../model';
// @ts-ignore
import { PostCustomersResponse } from '../model';
// @ts-ignore
import { PutCustomerRequest } from '../model';
// @ts-ignore
import { PutCustomersResponse } from '../model';
/**
 * CustomersApi - axios parameter creator
 * @export
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostCustomerRequest} postCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomer: async (postCustomerRequest: PostCustomerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postCustomerRequest' is not null or undefined
            assertParamExists('addCustomer', 'postCustomerRequest', postCustomerRequest)
            const localVarPath = `/api/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableCustomer: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('disableCustomer', 'id', id)
            const localVarPath = `/api/customers/{id}/disable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableCustomer: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enableCustomer', 'id', id)
            const localVarPath = `/api/customers/{id}/enable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCustomers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customers/activeCustomers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveLocationsByCustomerId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getActiveLocationsByCustomerId', 'id', id)
            const localVarPath = `/api/customers/{id}/active-locations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} country 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerBySearch: async (keyword: string, country: string, status: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyword' is not null or undefined
            assertParamExists('getAllCustomerBySearch', 'keyword', keyword)
            // verify required parameter 'country' is not null or undefined
            assertParamExists('getAllCustomerBySearch', 'country', country)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getAllCustomerBySearch', 'status', status)
            const localVarPath = `/api/customers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} country 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerByStringAndCountry: async (keyword: string, country: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyword' is not null or undefined
            assertParamExists('getAllCustomerByStringAndCountry', 'keyword', keyword)
            // verify required parameter 'country' is not null or undefined
            assertParamExists('getAllCustomerByStringAndCountry', 'country', country)
            const localVarPath = `/api/customers/search-customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerByStringAndStatus: async (keyword: string, status: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyword' is not null or undefined
            assertParamExists('getAllCustomerByStringAndStatus', 'keyword', keyword)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getAllCustomerByStringAndStatus', 'status', status)
            const localVarPath = `/api/customers/search-customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomerById', 'id', id)
            const localVarPath = `/api/customers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerByLocationId: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getCustomerByLocationId', 'locationId', locationId)
            const localVarPath = `/api/customers/location/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [country] 
         * @param {string} [status] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersByKeywordCountryStatus: async (limit: number, page: number, orderBy: string, orderDesc: string, country?: string, status?: string, keyword?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getCustomersByKeywordCountryStatus', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCustomersByKeywordCountryStatus', 'page', page)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('getCustomersByKeywordCountryStatus', 'orderBy', orderBy)
            // verify required parameter 'orderDesc' is not null or undefined
            assertParamExists('getCustomersByKeywordCountryStatus', 'orderDesc', orderDesc)
            const localVarPath = `/api/customers/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} keyword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersByText: async (keyword: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyword' is not null or undefined
            assertParamExists('getCustomersByText', 'keyword', keyword)
            const localVarPath = `/api/customers/search-text`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsByCustomerId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocationsByCustomerId', 'id', id)
            const localVarPath = `/api/customers/{id}/locations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalCustomer: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customers/get-total-customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutCustomerRequest} putCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: async (id: string, putCustomerRequest: PutCustomerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCustomer', 'id', id)
            // verify required parameter 'putCustomerRequest' is not null or undefined
            assertParamExists('updateCustomer', 'putCustomerRequest', putCustomerRequest)
            const localVarPath = `/api/customers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 * @export
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostCustomerRequest} postCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCustomer(postCustomerRequest: PostCustomerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCustomer(postCustomerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableCustomer(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableCustomer(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableCustomer(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableCustomer(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveCustomers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveCustomers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveLocationsByCustomerId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationsCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveLocationsByCustomerId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} country 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCustomerBySearch(keyword: string, country: string, status: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCustomerBySearch(keyword, country, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} country 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCustomerByStringAndCountry(keyword: string, country: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCustomerByStringAndCountry(keyword, country, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCustomerByStringAndStatus(keyword: string, status: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCustomerByStringAndStatus(keyword, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerByLocationId(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerByLocationId(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [country] 
         * @param {string} [status] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersByKeywordCountryStatus(limit: number, page: number, orderBy: string, orderDesc: string, country?: string, status?: string, keyword?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomersPagingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersByKeywordCountryStatus(limit, page, orderBy, orderDesc, country, status, keyword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} keyword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersByText(keyword: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersByText(keyword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationsByCustomerId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocationsCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationsByCustomerId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalCustomer(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTotalDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalCustomer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutCustomerRequest} putCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomer(id: string, putCustomerRequest: PutCustomerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomer(id, putCustomerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomersApi - factory interface
 * @export
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * 
         * @param {PostCustomerRequest} postCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomer(postCustomerRequest: PostCustomerRequest, options?: any): AxiosPromise<PostCustomersResponse> {
            return localVarFp.addCustomer(postCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableCustomer(id: string, options?: any): AxiosPromise<PutCustomersResponse> {
            return localVarFp.disableCustomer(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableCustomer(id: string, options?: any): AxiosPromise<PutCustomersResponse> {
            return localVarFp.enableCustomer(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCustomers(options?: any): AxiosPromise<GetCustomersResponse> {
            return localVarFp.getActiveCustomers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveLocationsByCustomerId(id: string, options?: any): AxiosPromise<GetLocationsCustomerResponse> {
            return localVarFp.getActiveLocationsByCustomerId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} country 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerBySearch(keyword: string, country: string, status: string, options?: any): AxiosPromise<GetCustomersResponse> {
            return localVarFp.getAllCustomerBySearch(keyword, country, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} country 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerByStringAndCountry(keyword: string, country: string, options?: any): AxiosPromise<GetCustomersResponse> {
            return localVarFp.getAllCustomerByStringAndCountry(keyword, country, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} keyword 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerByStringAndStatus(keyword: string, status: string, options?: any): AxiosPromise<GetCustomersResponse> {
            return localVarFp.getAllCustomerByStringAndStatus(keyword, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerById(id: string, options?: any): AxiosPromise<GetCustomerResponse> {
            return localVarFp.getCustomerById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerByLocationId(locationId: string, options?: any): AxiosPromise<GetCustomersResponse> {
            return localVarFp.getCustomerByLocationId(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(options?: any): AxiosPromise<GetCustomersResponse> {
            return localVarFp.getCustomers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [country] 
         * @param {string} [status] 
         * @param {string} [keyword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersByKeywordCountryStatus(limit: number, page: number, orderBy: string, orderDesc: string, country?: string, status?: string, keyword?: string, options?: any): AxiosPromise<GetCustomersPagingResponse> {
            return localVarFp.getCustomersByKeywordCountryStatus(limit, page, orderBy, orderDesc, country, status, keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} keyword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersByText(keyword: string, options?: any): AxiosPromise<GetCustomersResponse> {
            return localVarFp.getCustomersByText(keyword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsByCustomerId(id: string, options?: any): AxiosPromise<GetLocationsCustomerResponse> {
            return localVarFp.getLocationsByCustomerId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalCustomer(options?: any): AxiosPromise<GetTotalDataResponse> {
            return localVarFp.getTotalCustomer(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutCustomerRequest} putCustomerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(id: string, putCustomerRequest: PutCustomerRequest, options?: any): AxiosPromise<PutCustomersResponse> {
            return localVarFp.updateCustomer(id, putCustomerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addCustomer operation in CustomersApi.
 * @export
 * @interface CustomersApiAddCustomerRequest
 */
export interface CustomersApiAddCustomerRequest {
    /**
     * 
     * @type {PostCustomerRequest}
     * @memberof CustomersApiAddCustomer
     */
    readonly postCustomerRequest: PostCustomerRequest
}

/**
 * Request parameters for disableCustomer operation in CustomersApi.
 * @export
 * @interface CustomersApiDisableCustomerRequest
 */
export interface CustomersApiDisableCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomersApiDisableCustomer
     */
    readonly id: string
}

/**
 * Request parameters for enableCustomer operation in CustomersApi.
 * @export
 * @interface CustomersApiEnableCustomerRequest
 */
export interface CustomersApiEnableCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomersApiEnableCustomer
     */
    readonly id: string
}

/**
 * Request parameters for getActiveLocationsByCustomerId operation in CustomersApi.
 * @export
 * @interface CustomersApiGetActiveLocationsByCustomerIdRequest
 */
export interface CustomersApiGetActiveLocationsByCustomerIdRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetActiveLocationsByCustomerId
     */
    readonly id: string
}

/**
 * Request parameters for getAllCustomerBySearch operation in CustomersApi.
 * @export
 * @interface CustomersApiGetAllCustomerBySearchRequest
 */
export interface CustomersApiGetAllCustomerBySearchRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetAllCustomerBySearch
     */
    readonly keyword: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetAllCustomerBySearch
     */
    readonly country: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetAllCustomerBySearch
     */
    readonly status: string
}

/**
 * Request parameters for getAllCustomerByStringAndCountry operation in CustomersApi.
 * @export
 * @interface CustomersApiGetAllCustomerByStringAndCountryRequest
 */
export interface CustomersApiGetAllCustomerByStringAndCountryRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetAllCustomerByStringAndCountry
     */
    readonly keyword: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetAllCustomerByStringAndCountry
     */
    readonly country: string
}

/**
 * Request parameters for getAllCustomerByStringAndStatus operation in CustomersApi.
 * @export
 * @interface CustomersApiGetAllCustomerByStringAndStatusRequest
 */
export interface CustomersApiGetAllCustomerByStringAndStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetAllCustomerByStringAndStatus
     */
    readonly keyword: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetAllCustomerByStringAndStatus
     */
    readonly status: string
}

/**
 * Request parameters for getCustomerById operation in CustomersApi.
 * @export
 * @interface CustomersApiGetCustomerByIdRequest
 */
export interface CustomersApiGetCustomerByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetCustomerById
     */
    readonly id: string
}

/**
 * Request parameters for getCustomerByLocationId operation in CustomersApi.
 * @export
 * @interface CustomersApiGetCustomerByLocationIdRequest
 */
export interface CustomersApiGetCustomerByLocationIdRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetCustomerByLocationId
     */
    readonly locationId: string
}

/**
 * Request parameters for getCustomersByKeywordCountryStatus operation in CustomersApi.
 * @export
 * @interface CustomersApiGetCustomersByKeywordCountryStatusRequest
 */
export interface CustomersApiGetCustomersByKeywordCountryStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomersApiGetCustomersByKeywordCountryStatus
     */
    readonly limit: number

    /**
     * 
     * @type {number}
     * @memberof CustomersApiGetCustomersByKeywordCountryStatus
     */
    readonly page: number

    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetCustomersByKeywordCountryStatus
     */
    readonly orderBy: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetCustomersByKeywordCountryStatus
     */
    readonly orderDesc: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetCustomersByKeywordCountryStatus
     */
    readonly country?: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetCustomersByKeywordCountryStatus
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetCustomersByKeywordCountryStatus
     */
    readonly keyword?: string
}

/**
 * Request parameters for getCustomersByText operation in CustomersApi.
 * @export
 * @interface CustomersApiGetCustomersByTextRequest
 */
export interface CustomersApiGetCustomersByTextRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetCustomersByText
     */
    readonly keyword: string
}

/**
 * Request parameters for getLocationsByCustomerId operation in CustomersApi.
 * @export
 * @interface CustomersApiGetLocationsByCustomerIdRequest
 */
export interface CustomersApiGetLocationsByCustomerIdRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomersApiGetLocationsByCustomerId
     */
    readonly id: string
}

/**
 * Request parameters for updateCustomer operation in CustomersApi.
 * @export
 * @interface CustomersApiUpdateCustomerRequest
 */
export interface CustomersApiUpdateCustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomersApiUpdateCustomer
     */
    readonly id: string

    /**
     * 
     * @type {PutCustomerRequest}
     * @memberof CustomersApiUpdateCustomer
     */
    readonly putCustomerRequest: PutCustomerRequest
}

/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
export class CustomersApi extends BaseAPI {
    /**
     * 
     * @param {CustomersApiAddCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public addCustomer(requestParameters: CustomersApiAddCustomerRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).addCustomer(requestParameters.postCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiDisableCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public disableCustomer(requestParameters: CustomersApiDisableCustomerRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).disableCustomer(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiEnableCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public enableCustomer(requestParameters: CustomersApiEnableCustomerRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).enableCustomer(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getActiveCustomers(options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getActiveCustomers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetActiveLocationsByCustomerIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getActiveLocationsByCustomerId(requestParameters: CustomersApiGetActiveLocationsByCustomerIdRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getActiveLocationsByCustomerId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetAllCustomerBySearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getAllCustomerBySearch(requestParameters: CustomersApiGetAllCustomerBySearchRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getAllCustomerBySearch(requestParameters.keyword, requestParameters.country, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetAllCustomerByStringAndCountryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getAllCustomerByStringAndCountry(requestParameters: CustomersApiGetAllCustomerByStringAndCountryRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getAllCustomerByStringAndCountry(requestParameters.keyword, requestParameters.country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetAllCustomerByStringAndStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getAllCustomerByStringAndStatus(requestParameters: CustomersApiGetAllCustomerByStringAndStatusRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getAllCustomerByStringAndStatus(requestParameters.keyword, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetCustomerByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomerById(requestParameters: CustomersApiGetCustomerByIdRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomerById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetCustomerByLocationIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomerByLocationId(requestParameters: CustomersApiGetCustomerByLocationIdRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomerByLocationId(requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomers(options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetCustomersByKeywordCountryStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomersByKeywordCountryStatus(requestParameters: CustomersApiGetCustomersByKeywordCountryStatusRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomersByKeywordCountryStatus(requestParameters.limit, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, requestParameters.country, requestParameters.status, requestParameters.keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetCustomersByTextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomersByText(requestParameters: CustomersApiGetCustomersByTextRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomersByText(requestParameters.keyword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiGetLocationsByCustomerIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getLocationsByCustomerId(requestParameters: CustomersApiGetLocationsByCustomerIdRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getLocationsByCustomerId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getTotalCustomer(options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getTotalCustomer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomersApiUpdateCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public updateCustomer(requestParameters: CustomersApiUpdateCustomerRequest, options?: AxiosRequestConfig) {
        return CustomersApiFp(this.configuration).updateCustomer(requestParameters.id, requestParameters.putCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
